import React from 'react';
import { CpWidgetDidiverProps } from './cp-widget-divider';

export const CpRectangleWidgetDivider: React.FC<CpWidgetDidiverProps> = () => {
  return <></>;
};
